export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8859.72fc39ac.jpg";